import { z } from 'zod/v4';

import { termsAcceptedSchema } from '../../../schemas/terms-accepted.schema';

export const userProductSchema = z.object({
  licensed: z.boolean(),
  expired: z.boolean(),
  id: z.number(),
  name: z.string(),
  description: z.string(),
  homeUrl: z.string(),
  imageSource: z.string(),
  currentTermsOfUse: termsAcceptedSchema,
});

export type UserProduct = z.infer<typeof userProductSchema>;
